module.exports = __webpack_public_path__ + "media/images/promo/championship/dot-d71ea542bf5e55172e397f2739ccc38f.png";